





















































































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';
import {DateTime} from '@/utils/DateTime';

import SystemInfoStore from '@/store/system/SystemInfo.store';
import SystemUpgradeStore from '@/store/system/SystemUpgrade.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class SystemInfoOs extends Mixins<BaseComponent>(BaseComponent) {
  private DateTime = DateTime;

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private systemUpgradeStore: SystemUpgradeStore = getModule(SystemUpgradeStore, this.$store);

  private dialog = false;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.setLoading();
    await this.fetchOsInfo();
    await this.fetchRepositoryInfo();
    this.setLoaded();
  }

  private async fetchRepositoryInfo() {
    try {
      await this.systemUpgradeStore.fetchRepository();
      this.logger.info(`Update repository URL fetched`, this.systemUpgradeStore.Repository);
    } catch (error) {
      Notify.Error(this.logger, 'Could not load license information URL', error);
    }
  }

  private async fetchOsInfo() {
    try {
      await this.systemInfoStore.fetchOsInfo();
      this.logger.info(`OS info data fetched`, this.systemInfoStore.OsInfo);
    } catch (error) {
      Notify.Error(this.logger, 'Could not load OS info', error);
    }
  }

  private async copy(text: string) {
    await navigator.clipboard.writeText(text);

    Notify.Info(this.logger, 'The text has been copied to your clipboard');
  }
}
